export enum QuestNameEnum {
  BRIDGE_0_POINT_1_ETH = 'BRIDGE_0_POINT_1_ETH',
  BRIDGE_1_ETH = 'BRIDGE_1_ETH',
  REFERRAL_DEPOSIT_ANY_ETH = 'REFERRAL_DEPOSIT_ANY_ETH',
  MORE_THAN_10_REFERRALS_DEPOSIT_ANY_ETH = 'MORE_THAN_10_REFERRALS_DEPOSIT_ANY_ETH',
  REACH_10000_POINTS = 'REACH_10000_POINTS',
  REACH_50000_POINTS = 'REACH_50000_POINTS',
  REACH_100000_POINTS = 'REACH_100000_POINTS',
  REACH_200000_POINTS = 'REACH_200000_POINTS',
}
